export function getWaypointsAndShapes(waypointsAndShapes, ids) {
  return waypointsAndShapes.map(w => {
    if (w.objectType === 'routeSection') {
      return {
        ...w,
        sections: w.sections.filter(s => ids.includes(s.id))
      }
    }
    return w
  })
}

export function parseServerRoutingResp(res, responseHeaders) {
  let routeList = res.routes.concatenated_routes.map(item => {
    return Object.assign({}, res, {
      routes: {
        ...res.routes,
        concatenated_routes: [item],
        waypointsAndShapes: getWaypointsAndShapes(res.routes.waypointsAndShapes, item.ids)
      },
      responseHeaders: responseHeaders
    })
  })
  return routeList.map(routeJson => new Route(routeJson))
}

export class Route {
  constructor(routeJson) {
    this.routeJson = Object.freeze(routeJson)
    this.sections = this.getSections()
    this.shape = this.getShape()
    this.routeShape2 = this.getRoutShape2()
    this.v1Shape = this.getV1Shape()
    this.waypoint = this.getWaypoint()
    this.id = this.getId()
    this.summary = this.getSummary()
    this.responseHeaders = routeJson.responseHeaders
    this.segmentShape = this.getSegmentShape()
  }
  getSections() {
    let list = []
    let info = this.routeJson.routes.concatenated_routes[0]
    let index = 0
    this.routeJson.routes.waypointsAndShapes.forEach((ele, i) => {
      if (ele.objectType === 'routeSection') {
        let sections = Object.assign({}, ele.sections[0])
        let w = i > 0 ? this.routeJson.routes.waypointsAndShapes[i - 1] : null
        let dwellTime = 0
        if (w && w.dwellTime) {
          dwellTime = w.dwellTime
        }
        sections.summary = Object.assign({}, sections.summary, {
          tollCost: info.section_tolls ? info.section_tolls[index] : 0,
          durationAndDwellTime: sections.summary.duration + dwellTime
        })
        list.push(sections)
        index += 1
      }
    })
    return Object.freeze(list)
  }
  getShape() {
    let shape = []
    this.sections.forEach(item => {
      shape = shape.concat(item.showShape)
    })
    return Object.freeze(shape)
  }
  getV1Shape() {
    let shape = []
    this.sections.forEach(item => {
      item.showShape.map(s => {
        shape.push(...s)
      })
    })
    return Object.freeze(shape)
  }
  getRoutShape2() {
    let shape = []
    this.sections.forEach(item => {
      shape = shape.concat(item.routeShape2)
    })
    return Object.freeze(shape)
  }
  getWaypoint() {
    let waypoint = []
    let shapeLen = 0
    let list = Object.freeze(this.routeJson.routes.waypointsAndShapes)
    list.map((item, index) => {
      if (item.objectType === 'waypoint') {
        let mappedPosition = {}
        if (index === list.length - 1) {
          let showShape = list[index - 1].sections[0].showShape
          let s = showShape[showShape.length - 1]
          mappedPosition = { latitude: s[0], longitude: s[1] }
        } else {
          let showShape = list[index + 1].sections[0].showShape
          let s = showShape[0]
          mappedPosition = { latitude: s[0], longitude: s[1] }
        }
        waypoint.push({
          ...item,
          mappedPosition: mappedPosition,
          originalPosition: { latitude: item.originalLocation.lat, longitude: item.originalLocation.lng },
          mappedRoadName: '',
          v1ShapeIndex: index === 0 ? 0 : shapeLen - 2
        })
      } else {
        let showShape = item.sections[0].showShape
        shapeLen += showShape.length * 2
      }
    })
    return waypoint
  }
  getId() {
    let info = this.routeJson.routes.concatenated_routes[0]
    return info.ids.join('-')
  }
  getSummary() {
    let departure = Number(this.waypoint[0].departureTime)
    let info = this.routeJson.routes.concatenated_routes[0]
    let dwellTimeAll = this.waypoint.reduce((a,b) => a + b.dwellTime, 0)
    return {
      distance: info.length,
      duration: info.duration,
      totalCost: info.tolls,
      departure: departure,
      arrival: departure + info.duration + dwellTimeAll
    }
  }
  getSegmentShape() {
    let shapeList = []
    for(let i = 0; i < this.waypoint.length - 1; i++) {
      let via = this.waypoint[i].via
      let showShape = this.sections[i].showShape
      if (via) {
        let startOffset = 0
        let list = []
        via.map(v => {
          // Offset + 1 is the corresponding index in showShape, this is a problem with HERE MAP itself
          list.push(showShape.slice(startOffset, v.offset + 2).map(s => ({ lat: s[0], lng: s[1] })))
          // offset + 1 Prevent the two routes from not being connected
          startOffset = v.offset + 1
        })
        list.push(showShape.slice(startOffset, showShape.length).map(s => ({ lat: s[0], lng: s[1] })))
        shapeList.push(list)
      } else {
        shapeList.push([showShape.map(s => ({ lat: s[0], lng: s[1] }))])
      }
    }
    return Object.freeze(shapeList)
  }
}